/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { SelectInput } from '@ui/molecules/inputs';`
 * Or: `import { SelectInput } from '@ui/molecules/inputs/form';`
 *
 * Or specific path: `import { SelectInput } from '@ui/molecules/inputs/form/SelectInput';`
 *
 * See the new component for documentation and migration notes.
 */
import React, { useRef, useState, useMemo, useEffect } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Popup } from '@progress/kendo-react-popup';
import './SelectStyles.scss';
export default function Select({ id, className, optionRenderer, valueRenderer, options, label, value, onChange, showSearch = false, searchPlaceholder = 'Search options...', maxHeight, disabled = false }) {
    var _a;
    const [visible, setVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const anchor = useRef(null);
    const searchInputRef = useRef(null);
    // Filter options based on search term
    const filteredOptions = useMemo(() => {
        if (!showSearch || !searchTerm.trim()) {
            return options;
        }
        return options.filter((option) => String(option.label).toLowerCase().includes(searchTerm.toLowerCase()));
    }, [options, searchTerm, showSearch]);
    // Focus search input when dropdown opens
    useEffect(() => {
        if (visible && showSearch && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [visible, showSearch]);
    const handleOpen = () => {
        setVisible(true);
        setSearchTerm('');
    };
    const handleClose = () => {
        setVisible(false);
        setSearchTerm('');
    };
    return (React.createElement("div", { className: className ? `${className} v2-select-container` : 'v2-select-container' },
        React.createElement("button", { type: "button", className: "qmb-control--menu content-actions__toggle", onClick: handleOpen, ref: anchor, disabled: disabled },
            label ? React.createElement(React.Fragment, null,
                label,
                ": ") : '',
            React.createElement("span", { className: "selectValue" }, (valueRenderer === null || valueRenderer === void 0 ? void 0 : valueRenderer(value)) || ((_a = options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label))),
        React.createElement(Popup, { anchor: anchor.current, show: visible, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose, onKeyDown: (e) => {
                    if (e.key === 'Escape') {
                        handleClose();
                    }
                } },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list v2-select-container", style: maxHeight ? { maxHeight: `${maxHeight}px`, overflowY: 'auto' } : {} },
                    showSearch && (React.createElement("div", { className: "searchContainer" },
                        React.createElement("input", { ref: searchInputRef, type: "text", className: "searchInput", placeholder: searchPlaceholder, value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }),
                        React.createElement("i", { className: "fa-light fa-magnifying-glass searchIcon", "aria-hidden": "true" }))),
                    React.createElement("ul", { id: id, role: "presentation", style: maxHeight ? { maxHeight: `${maxHeight - (showSearch ? 60 : 0)}px`, overflowY: 'auto' } : {} },
                        filteredOptions.map((option) => (optionRenderer === null || optionRenderer === void 0 ? void 0 : optionRenderer(option)) || (React.createElement("li", { key: option.value, role: "presentation" },
                            React.createElement("button", { type: "button", className: "selectOption", onClick: () => {
                                    onChange(option.value);
                                    handleClose();
                                } }, option.label)))),
                        filteredOptions.length === 0 && showSearch && searchTerm.trim() && (React.createElement("li", { style: { padding: '8px 12px', color: '#666', fontStyle: 'italic' } }, "No options found"))))))));
}
